// extracted by css-extract-rspack-plugin
export default {"refreshLink":"ChFtu","disabled":"g4vHY"};